import lazySizes from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/bgset/ls.bgset';

window.lazySizesConfig = Object.assign(window.lazySizesConfig || {}, {
    init: false
});

export default lazySizes;
